import { createError, defineNuxtPlugin } from "#app";

import type { SolvariEnv } from "@solvari/utils";

import { useGlobal } from "@solvari/utils";

import { kyCacheTags } from "~/shared/composables/useCacheTags.ts";
import { toInternalUrl, useHostLocale } from "~/shared/composables/useHost.ts";
import { getSolvariEnv } from "~/shared/libs/solvariEnv.ts";
import { useQueryAsync } from "~/shared/libs/useQueryAsync.ts";

export default defineNuxtPlugin(async () => {
  const locale = useHostLocale();

  const result = await useQueryAsync({
    key: () => ["solvari-env", locale],
    query: () =>
      import.meta.server
        ? getSolvariEnv(locale)
        : kyCacheTags
            .get(toInternalUrl(`/cache-proxy/api/v3/solvari-env`), {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              headers: { "solvari-locale": locale },
              timeout: 20_000,
            })
            .json<SolvariEnv>(),
    staleTime: Infinity,
  });

  if (result instanceof Error) {
    throw createError(result);
  }

  useGlobal<SolvariEnv>("solvariEnv").set(result);
});
